module.exports = __webpack_public_path__ + "static/media/retiro-azul.625400f4.svg";